import { inject, Injectable } from '@angular/core';
import { CurrentStateService } from '@ddv/behaviors';
import { ApiServices, ApiExecutorService } from '@ddv/http';
import { Client } from '@ddv/models';
import { map, mergeMap, Observable, of, shareReplay, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ClientsService {
    private readonly currentState = inject(CurrentStateService);
    private readonly trebekApiExecutor = inject<ApiExecutorService>(ApiServices.trebek);

    private clients$: Observable<string[]> | undefined;
    private readonly cachedClients$: Observable<string[]> = this.getClients().pipe(
        map((clients) => clients.sort((a, b) => a.localeCompare(b))),
        shareReplay(1),
    );

    /** @deprecated relies on current-state service **/
    clients(): Observable<string[]> {
        this.clients$ ??= this.currentState.isMultiClient$.pipe(switchMap((isMulti) => {
            return isMulti ? this.cachedClients$ : of([]);
        }));

        return this.clients$;
    }

    fetchClients(clientCode: string): Observable<Client[]> {
        return this.trebekApiExecutor.invokeServiceWithParams<string[]>(clientCode, '/reference-data/client-list')
            .pipe(
                map((codes) => codes.map((code) => ({ clientId: code, clientName: code }))),
            );
    }

    private get clientsEndpoint(): Observable<{ clientCode: string, route: string }> {
        return this.currentState.clientCode$.pipe(
            map((clientCode) => {
                return {
                    clientCode,
                    route: '/reference-data/client-list',
                };
            }),
        );
    }

    private getClients(): Observable<string[]> {
        return this.clientsEndpoint.pipe(
            mergeMap(({ clientCode, route }) => this.trebekApiExecutor.invokeServiceWithParams<string[]>(clientCode, route)),
        );
    }
}
